import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeng/themes/aura';
import { definePreset } from '@primeng/themes';
import { routes } from './app.routes';
import { authInterceptor } from './core/auth/auth.interceptor';
import { cryptoApiInterceptor } from './core/auth/crypto-api.interceptor';
import { conciliacionesApiInterceptor } from './core/auth/conciliaciones-api.interceptor';

const PeruMoneyPreset = definePreset(Aura, {
  semantic: {
    primary: {
      50: '#e8faf0',
      100: '#c5f2db',
      200: '#9fe9c3',
      300: '#72dfaa',
      400: '#4edda0',
      500: '#25d07b',
      600: '#1eb86b',
      700: '#169e5b',
      800: '#0f844b',
      900: '#096a3b',
      950: '#04501e',
    },
    colorScheme: {
      light: {
        primary: {
          color: '#25d07b',
          inverseColor: '#ffffff',
          hoverColor: '#1eb86b',
          activeColor: '#169e5b',
        },
        highlight: {
          background: '#25d07b',
          focusBackground: '#1eb86b',
          color: '#ffffff',
          focusColor: '#ffffff',
        },
      },
      dark: {
        primary: {
          color: '#25d07b',
          inverseColor: '#ffffff',
          hoverColor: '#4edda0',
          activeColor: '#1eb86b',
        },
        highlight: {
          background: '#25d07b',
          focusBackground: '#1eb86b',
          color: '#ffffff',
          focusColor: '#ffffff',
        },
      },
    },
  },
});

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withComponentInputBinding()),
    provideHttpClient(withInterceptors([authInterceptor, cryptoApiInterceptor, conciliacionesApiInterceptor])),
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: PeruMoneyPreset,
        options: {
          prefix: 'p',
          darkModeSelector: '.dark-mode',
          cssLayer: false,
        },
      },
    }),
  ],
};
